"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGatsbyImage = void 0;

var isGatsbyImage = function isGatsbyImage(image) {
  return typeof image !== 'string' && !!image && (!!image.fixed || !!image.fluid);
};

exports.isGatsbyImage = isGatsbyImage;